import React, {useEffect} from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardContent, Typography, Grid, Hidden } from "@material-ui/core";
import { useMediaQuery } from "react-responsive";
import BackLink from "./_back-link";
import { useDispatch } from "react-redux";
import SearchBar from "../../content-section/view/_search-bar";
import { searchSubmit } from "../../content-section/model/content-actions";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  heading: {
    margin: "auto",
  },
  searchBar: {
    width: "60%",
    height: "80%",
    margin: "auto",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  smSearchBar: {
    width: "100%",
    height: "80%",
    margin: "auto",
  },
}));

export default function SearchHeader(props) {
  const classes = useStyles();
  const smQuery = useMediaQuery({ query: "(min-width: 600px)" });
  const labels = useSelector((state) => state?.labels?.data?.getLabels?.SEARCH);
  let Keyword = new URLSearchParams(window.location.search).get("q");
  const dispatch = useDispatch();

  const handleSubmitSearch = (keyword) => {
    dispatch(searchSubmit(keyword));
  };

  const submitHandler = (Keyword) => {
    props.submitHandlesearch1(Keyword);
  };

  useEffect(() => {
    handleSubmitSearch(Keyword);
    props.submitHandlesearch1(Keyword);
  }, [Keyword]);
  
  return (
    <Grid direction="column" container className={classes.root}>
      <Grid
        container
        alignItems="center"
        justify="space-between"
        direction="row"
      >
        <Grid item xs={1}>
          <BackLink />
        </Grid>
        <Grid item xs={6}>
          <Typography
            color="primary"
            gutterBottom
            variant="h6"
            component="h2"
            align="center"
          >
            <b>{labels?.SEARCH_SEARCH}</b>
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <div>
            {" "}
            <br />
          </div>
        </Grid>
      </Grid>

      <Grid item className={smQuery ? classes.searchBar : classes.smSearchBar}>
        <SearchBar
          isDefault={true}
          submitHandler={(Keyword) => submitHandler(Keyword)}
        />
      </Grid>
    </Grid>
  );
}
